import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Header, Footer } from "../components/layout/SiteChrome";
import { request } from "../services/api";
import { imageUrl } from "../services/config";

export default function CategoryPage() {
  const { categoryId } = useParams<{ categoryId: string }>();
  const [categories, setCategories] = useState<any[]>([]);
  const [brands, setBrands] = useState<any[]>([]);
  const [allNodes, setAllNodes] = useState<any[]>([]);
  const [products, setProducts] = useState<any[]>([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    request('/categories').then(data => setCategories(data.categories || [])).catch(console.error);
    request(`/nodes?parentId=null&categoryId=${categoryId}`).then(data => setBrands(data.nodes || [])).catch(console.error);
    request('/nodes').then(data => setAllNodes(data.nodes || [])).catch(console.error);
    request('/products').then(data => setProducts(data.products || [])).catch(console.error);
  }, [categoryId]);

  const cat = categories.find(c => c._id === categoryId);
  const filtered = brands.filter(b => b.name.toLowerCase().includes(q.toLowerCase()));

  const brandHasProducts = (brandId: string) => {
    const descendantIds: string[] = [brandId];
    const stack = [brandId];
    while (stack.length) {
      const cur = stack.pop()!;
      allNodes.forEach((n: any) => {
        const parentId = typeof n.parentId === 'string' ? n.parentId : n.parentId?._id;
        if (parentId === cur && !descendantIds.includes(n._id)) {
          descendantIds.push(n._id);
          stack.push(n._id);
        }
      });
    }
    return products.some((p: any) => {
      const pNodeId = p.nodeId?._id || p.nodeId;
      return descendantIds.includes(pNodeId);
    });
  };

  const sortedBrands = [...filtered].sort((a: any, b: any) => {
    const aHas = brandHasProducts(a._id);
    const bHas = brandHasProducts(b._id);
    if (aHas && !bHas) return -1;
    if (!aHas && bHas) return 1;
    return 0;
  });

  return (
    <div className="page-bg">
      <Header />
      <section style={{ background: "var(--indigo)", padding: "44px 20px 40px" }}>
        <div style={{ maxWidth: 1160, margin: "0 auto" }}>
          <Link to="/" style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 13, color: "rgba(255,255,255,0.55)", textDecoration: "none", marginBottom: 18, transition: "color 0.2s" }}
            onMouseEnter={e => (e.currentTarget.style.color = "#fff")} onMouseLeave={e => (e.currentTarget.style.color = "rgba(255,255,255,0.55)")}>
            ← Back to Home
          </Link>
          <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 20, flexWrap: "wrap" }}>
            <div style={{ width: 50, height: 50, display: "flex", alignItems: "center", justifyContent: "center" }}>
              {cat?.image?.url ? (
                <img 
                  src={imageUrl(cat.image.url)} 
                  alt="" 
                  style={{ width: "100%", height: "100%", objectFit: "contain" }} 
                />
              ) : (
                <span style={{ fontSize: 40 }}>{cat?.icon}</span>
              )}
            </div>
            <div>
              <h1 style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "clamp(24px,4vw,34px)", color: "#fff", letterSpacing: "-0.5px" }}>{cat?.name ?? "Devices"}</h1>
              <p style={{ color: "rgba(255,255,255,0.65)", fontSize: 14, marginTop: 4 }}>Select your brand to get an instant price</p>
            </div>
          </div>
          <div className="banner-search">
            <span className="banner-search__icon">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="var(--indigo)" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.35-4.35" />
              </svg>
            </span>
            <input value={q} onChange={e => setQ(e.target.value)} placeholder="Search brand..."
              style={{ color: "var(--text)" }} />
            {q && (
              <button type="button" onClick={() => setQ("")} className="banner-search__clear" aria-label="Clear search">✕</button>
            )}
          </div>
        </div>
      </section>

      <section style={{ maxWidth: 1160, margin: "0 auto", padding: "44px 20px 64px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))", gap: 14 }}>
          {sortedBrands.map((b, i) => (
            <Link key={b._id} to={`/brand/${b._id}`}
              className="animate-fade-up" style={{ animationDelay: `${i * 45}ms`, textDecoration: "none", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 9, background: "var(--surface)", border: "1.5px solid var(--border)", borderRadius: 14, padding: "22px 12px", transition: "all 0.22s", boxShadow: "var(--shadow-sm)" }}
              onMouseEnter={e => { const el = e.currentTarget as HTMLElement; el.style.borderColor = "#1D9E75"; el.style.transform = "translateY(-3px)"; el.style.boxShadow = "var(--shadow-lg)"; }}
              onMouseLeave={e => { const el = e.currentTarget as HTMLElement; el.style.borderColor = "var(--border)"; el.style.transform = ""; el.style.boxShadow = "var(--shadow-sm)"; }}>
              <div style={{ width: 46, height: 46, borderRadius: 11, background: `#1D9E7516`, border: `1.5px solid #1D9E7528`, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", padding: b.image?.url ? 6 : 0 }}>
                {b.image?.url ? (
                  <img 
                    src={imageUrl(b.image.url)} 
                    alt="" 
                    style={{ width: "100%", height: "100%", objectFit: "contain" }} 
                  />
                ) : (
                  <span style={{ fontSize: 18, fontWeight: 700, fontFamily: "var(--font-display)", color: "#1D9E75" }}>{b.icon}</span>
                )}
              </div>
              <span style={{ fontSize: 13, fontWeight: 600, color: "var(--text)" }}>{b.name}</span>
            </Link>
          ))}
        </div>
        {sortedBrands.length === 0 && (
          <div style={{ textAlign: "center", padding: "72px 0", color: "var(--text2)" }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>🔍</div>
            <p style={{ fontSize: 15 }}>No brands found for "{q}"</p>
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
